'use strict';

import template
    from '../../../../templates/settings/integrations/xero/PayrollItem.ejs';
import RowEditView from 'commons/views/RowEdit';

module.exports = RowEditView.extend({
    tagName: 'tr',

    events: function() {
        return Object.assign({}, RowEditView.prototype.events() || {}, {
            'change .js-integration[name=remoteId]': 'updateIntegration'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            deletable: true,
        });

        this.options.templateExtra = {
            debitAccounts: this.options.debitAccounts,
            creditAccounts: this.options.creditAccounts,
            contacts: this.options.contacts,
            mapping: this.options.mapping,
            mappingType: this.options.mappingType,
        };

        return RowEditView.prototype.initialize.apply(this, [this.options]);
    },

    updateIntegration: function(ev) {
        let $input = this.$(ev.currentTarget);
        let remoteId = this.getInputValue($input);
        let remoteName = $.trim(
            $input.find(`option[value="${remoteId}"]`).text()
        );

        this.model.set({
            remoteId: remoteId,
            remoteName: remoteName
        });
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/integrations/xero/PayrollItem.js